module.exports = __webpack_public_path__ + "static/media/video-2.2875f6d2.jpg";